import { render, staticRenderFns } from "./Partners.vue?vue&type=template&id=7288e016&scoped=true&"
import script from "./Partners.vue?vue&type=script&lang=ts&setup=true&"
export * from "./Partners.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./Partners.vue?vue&type=style&index=0&id=7288e016&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7288e016",
  null
  
)

export default component.exports